import { FC } from 'react'

import { CompanyQRsTable as Table } from 'bank-quarterly-report'

import { CompanyQRTableProps } from './CompanyQRsTableProps'

export const CompanyQRsTable: FC<CompanyQRTableProps> = ({ data }) => <Table data={data} />
